import {useFormContext} from '@yandex-delivery/form'
import {useEffect, useRef} from 'react'

import {DeliveryType} from 'src/shared/types'

import {persistFormValues} from '../../consts'
import {useVerticalType} from '../../hooks/use-vertical-type'

export function useOrderForm() {
  const {watch} = useFormContext()
  const {rawVertical} = useVerticalType()
  const isNddVertical = rawVertical === DeliveryType.NDD_Self_Pickup || rawVertical === DeliveryType.NDD_Shipment
  const isCargoVertical = rawVertical === DeliveryType.Cargo
  const isWalkingVertical = rawVertical === DeliveryType.Walking_Courier
  const formRef = useRef<HTMLDivElement>()
  const sentinelRef = useRef<HTMLDivElement>(null)

  function refHandler(element: HTMLDivElement) {
    formRef.current = element
  }

  useEffect(() => {
    // в процессе до меня дошло, что вот эта конструкция это аналог миддлвар из редакса
    // опуская момент с тем, что в редаксе можно менять стейт из миддлвар
    // ----
    // каст нужен, потому watch не типизирован, ругается что не тот стейт в аргументах
    // но мы то знаем, что туда приходит на самом деле
    return watch(persistFormValues as unknown as VoidFunction).unsubscribe
  }, [watch])

  return {
    isNddVertical,
    isCargoVertical,
    isWalkingVertical,
    rawVertical,
    formRef,
    refHandler,
    sentinelRef,
  } as const
}
